import React, { FC, memo } from 'react'
import { ESportsCodes } from 'astra-core/containers/CommonDataProvider'
import { ESportsCounterType } from 'astra-core/containers/SportCountersProvider/types'
import { useParams } from 'react-router-dom'
import { selectSportsCountersListV2 } from 'astra-core/containers/SportCountersProvider/selectors'

import { SportIcon } from 'shared/ui/Icon/SportIcon'
import { useAppSelector } from 'store'

import { ResultsMenuItemProps } from './CalendarMenuList.types.ts'
import {
  StyledSportsMenuItem,
  StyledSportsMenuItemCount,
  StyledSportsMenuItemText,
  StyledSportsMenuList
} from './CalendarMenuList.styled'

export const CalendarMenuList = () => {
  const calendarCountersList = useAppSelector((state) =>
    selectSportsCountersListV2(state, ESportsCounterType.CALENDAR)
  )

  return (
    <StyledSportsMenuList>
      {calendarCountersList.map((sport) => (
        // @ts-ignore
        <ResultsMenuItem key={sport.id} sport={sport}>
          {sport.name}
        </ResultsMenuItem>
      ))}
    </StyledSportsMenuList>
  )
}

const ResultsMenuItem: FC<ResultsMenuItemProps> = memo(({ sport }) => {
  const { sportId } = useParams<{ sportId: string }>()

  const isActive = Number(sportId) === sport.id

  return (
    <StyledSportsMenuItem active={isActive} to={`/calendar/${sport.id}`}>
      <SportIcon
        isActive={sport.top}
        sportCode={sport.code as ESportsCodes}
        withBackground
      />

      <StyledSportsMenuItemText>{sport.name}</StyledSportsMenuItemText>

      <StyledSportsMenuItemCount>{sport.count}</StyledSportsMenuItemCount>
    </StyledSportsMenuItem>
  )
})
